import { Serializable } from "../utilities/Serializable";

export class CardType extends Serializable {
    uuid: string;
    name: string;
    credit: boolean;
    service: boolean;
    dailyPlafond: number;
    plafond: number;
    additionalCircuits: CardType[];

    constructor() {
        super();
        this.name = "";
    }
}


// WEBPACK FOOTER //
// ./src/app/models/CardType.ts